import React from "react";
import { WidgetType, WidgetEntity } from "../types";
import { WidgetTable } from "./WidgetTable";
import { WidgetCard } from "./WidgetCard";
import { WidgetObject } from "./WidgetObject";
import { WidgetFile } from "./WidgetFile";
import { WidgetList } from "./WidgetList";
import { Markdown } from "./Markdown";

export interface WidgetOutputProps {
  widget: WidgetType;
  content: unknown;
  propertyTicker: string;
  entity?: WidgetEntity;
}

export function WidgetOutput({
  widget,
  content,
  propertyTicker,
  entity,
}: WidgetOutputProps): React.JSX.Element {
  switch (widget) {
    case "table":
      return <WidgetTable content={content} propertyTicker={propertyTicker} entity={entity} />;
    case "card":
      return <WidgetCard content={content} />;
    case "object":
      return <WidgetObject content={content} propertyTicker={propertyTicker} entity={entity} />;
    case "file":
      return <WidgetFile content={content} />;
    case "list":
      return <WidgetList content={content} />;
    case "none":
      // The tool produced no renderable widget (e.g. a successful deletion). The
      // assistant's plain text message already communicates the result.
      return <></>;
    case "markdown":
    case "text":
    default:
      return <Markdown>{String(content ?? "")}</Markdown>;
  }
}
